import {
  getAnalyticsPageType,
  getVideoPostWrapperName,
  calculateVideoTimePercent,
} from '../../jsCore/utils/video'
import { dispatch } from '../../jsCore/application/appStore'
import {
  youtubeAnalyticsCompleteAction,
  youtubeAnalyticsPlayAction,
  youtubeAnalyticsPauseAction,
  youtubeAnalyticsPercentageChangeAction,
} from './youtubeActions'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'

function getAnalyticsVideoBaseData(videoPlayer) {
  return {
    videoID: videoPlayer.getVideoData().video_id,
    pageType: getAnalyticsPageType(),
    videoMainWrapperName: getVideoPostWrapperName(videoPlayer.getIframe()),
    duration: videoPlayer.getDuration(),
    currentTime: videoPlayer.getCurrentTime(),
  }
}

const playerStateHandlers = [
  youtubeAnalyticsCompleteAction,
  youtubeAnalyticsPlayAction,
  youtubeAnalyticsPauseAction,
]

function onPlayerStateChange(evt) {
  const {
    videoID,
    pageType,
    videoMainWrapperName,
    duration,
    currentTime,
  } = getAnalyticsVideoBaseData(evt.target)

  if (!playerStateHandlers[evt.data]) {
    return
  }

  dispatch(
    playerStateHandlers[evt.data](videoID, pageType, videoMainWrapperName, {
      duration,
      position: currentTime,
    })
  )
}

function handleVideoPostMessage() {
  let lastRegisteredStep = -1

  return function videoMessage(msgEvent) {
    if (msgEvent.origin !== 'https://www.youtube.com') {
      return
    }
    if (typeof msgEvent.data !== 'string') {
      return
    }
    const videoMessageData = JSON.parse(msgEvent.data)

    if (videoMessageData.event !== 'infoDelivery') {
      return
    }

    const playerIframeID = videoMessageData.channel + (videoMessageData.id + 1)
    const currentPlayer = YT.get(playerIframeID)
    const {
      videoID,
      pageType,
      videoMainWrapperName,
      duration,
      currentTime,
    } = getAnalyticsVideoBaseData(currentPlayer)
    const percentageStep = calculateVideoTimePercent(duration, currentTime)

    if (percentageStep.constructor === Number && lastRegisteredStep !== percentageStep) {
      dispatch(
        youtubeAnalyticsPercentageChangeAction(
          videoID,
          pageType,
          videoMainWrapperName,
          {
            duration,
            position: currentTime,
          },
          percentageStep
        )
      )
      lastRegisteredStep = percentageStep
    }
  }
}

function registerToYoutubeEvents(youtubeIframes) {
  window.onYouTubeIframeAPIReady = function() {
    Array.map(youtubeIframes, currentPlayer => {
      let player = new YT.Player(currentPlayer, {
        events: {
          onStateChange: onPlayerStateChange,
        },
      })
    })
    window.addEventListener('message', handleVideoPostMessage())
  }
}
function loadYoutubeApiScript() {
  externalScriptLoader.load({
    config: {
      src: externalScriptsConfig.youtube.src,
      name: externalScriptsConfig.youtube.name,
    },
  })()
}

export function trackAnalyticsYoutubeEvents() {
  const youtubeIframes = document.querySelectorAll('iframe.Youtube')
  if (youtubeIframes.length > 0) {
    loadYoutubeApiScript()
    registerToYoutubeEvents(youtubeIframes)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/track_analytics_youtube_events/trackAnalyticsYoutubeEvents.js